export default __webpack_public_path__ + "static/1225-ce47d37e5f3e8937820c4f47df8747f9.gif";